export enum ActionTypes {
  GET_WEATHER_DATA = "GET_WEATHER_DATA",
  GET_WEATHER_DATA_SUCCESS = "GET_WEATHER_DATA_SUCCESS",
  GET_WEATHER_DATA_FAILURE = "GET_WEATHER_DATA_FAILURE",
  GET_LOCATION_POSITION = "GET_LOCATION_POSITION",
  WEATHER_DEGREE_IS_CELSIUS = "WEATHER_DEGREE_IS_CELSIUS",
  WEATHER_DEGREE_IS_FAHRENHEIT = "WEATHER_DEGREE_IS_FAHRENHEIT",
  GET_LOCATION_FROM_MAP = "GET_LOCATION_FROM_MAP",
  GET_LOCATION_COORDINATES = "GET_LOCATION_COORDINATES",
  GET_CURRENT_LOCATION_POSITION = "GET_CURRENT_LOCATION_POSITION",
  GET_CURRENT_LOCATION_POSITION_DENIED = "GET_CURRENT_LOCATION_POSITION_DENIED",
}
